// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton-module--closeButton--6d6be1"};